import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';

Alpine.plugin(collapse);
Alpine.plugin(focus);

document.addEventListener("alpine:init", () => {

	Alpine.data('liveSearch', () => ({
		navbarShow: false,
		searchShow: false,
		enabled: false,
		navSection: 0,
		isLoading: false,
		stateLoading: {
			venue: false,
			event: false,
			guide: false
		},
		results: {},
		total: 0,
		searchString: '',
		error: null,
		init() {

			const $body = document.querySelector('body');

			this.$watch('enabled', () => {
				if( this.enabled ){
					$body.classList.add('drop-active');
				}else{
					$body.classList.remove('drop-active');
				}
			});


		},
		toggleNavbar() {
			this.navbarShow = !this.navbarShow;
			this.searchShow = false;

			this.enabled = this.navbarShow;
		},
		toggleSearch( touch=false ) {
			this.searchShow = true;
			this.navbarShow = false;
			if( touch ){
				this.$nextTick(() => { 
					setTimeout(() => { 
						this.$refs.searchfieldTouch.focus(); 
					}, 100); 
				});
			}
			this.enabled = this.searchShow;
		},
		selectSection(id){
			this.navSection = id;
		},
		async fetchItems(post_type) {
			this.stateLoading[post_type] = true;
			try {
				const res = await fetch(`/wp-json/ct/v4/live-search?s=${encodeURIComponent(this.searchString)}&post_type=${post_type}`);
				const data = await res.json();
				if (Array.isArray(data) && data.length > 0) {
					this.results[post_type + 's'] = data;
					this.total += data.length;
				}else{
					delete this.results[post_type + 's'];
				}
				
				return data;
			} catch (error) {
				this.error = error;
			} finally {
				this.stateLoading[post_type] = false;
			}
		},
		async doLiveSearch(){
			this.clearSearch();
			// If no top picks then dont open search right away
			this.toggleSearch();
			this.isLoading = true;

			await Promise.all([
				this.fetchItems('event'),
				this.fetchItems('guide'),
				this.fetchItems('venue')
			]);

			if( this.total === 0 ){
				this.error = 'Sorry no results for this search term, please check and try again';
			}else {
				this.error = null;
			}

			this.isLoading = false;
		},
		doSearch() {
			if( this.searchString ){
				window.location = `/?s=${ this.searchString }`;
			}
		},
		clearSearch() {
			this.total = 0;
			this.results = {};
			this.isLoading = false;
		},
		destroy() {
			this.$refs.searchfield.blur();
			this.$refs.searchfieldTouch.blur();
			this.navbarShow = false;
			this.searchShow = false; 
			this.clearSearch(); 
			this.searchString = null;
			this.enabled = false;
		}
	}));

});
